import { useEffect, useState } from "react";
import { Building2, Folder, Home } from "lucide-react";
import { useCompany } from "@/context/CompanyContext";
import { api } from "@/lib/api";
import { useMe } from "@/context/MeContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function MoveDialog({ open, onOpenChange, title, excludeId, onSubmit, allowCompanies = false }) {
  const { me } = useMe();
  const { companies, current } = useCompany();
  const [tree, setTree] = useState([]);
  const [filter, setFilter] = useState("");
  const [target, setTarget] = useState(undefined);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    setTarget(undefined); setFilter("");
    api.get("/folders/tree").then((r) => setTree(r.data));
  }, [open]);

  const list = tree.filter((f) => f.id !== excludeId && !f.path.includes(`${excludeId}`) && f.path.toLowerCase().includes(filter.toLowerCase()));
  const submit = async () => {
    setBusy(true);
    try {
      if (typeof target === "string" && target.startsWith("company:")) await onSubmit(null, target.slice(8));
      else await onSubmit(target);
      onOpenChange(false);
    } finally { setBusy(false); }
  };
  const Row = ({ id, label, icon: I }) => (
    <button type="button" onClick={() => setTarget(id)} data-testid={`move-target-${id || "root"}`}
      className={`w-full flex items-center gap-2 px-3 py-2 text-sm rounded-md text-left ${target === id ? "bg-[#1E3A8A] text-white" : "hover:bg-slate-100"}`}>
      <I className="h-4 w-4 shrink-0" /><span className="truncate">{label}</span>
    </button>
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="move-dialog">
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <Input placeholder="Filtrer les dossiers…" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="move-filter-input" />
        <div className="max-h-72 overflow-auto border rounded-md p-1 space-y-0.5">
          {allowCompanies && me.role !== "externe" && companies.filter((c) => c.id !== current).length > 0 && (
            <div className="pb-2 mb-1 border-b">
              <div className="px-3 py-1 text-[10px] uppercase tracking-wider font-semibold text-slate-500">Vers une autre société (racine)</div>
              {companies.filter((c) => c.id !== current).map((c) => <Row key={c.id} id={`company:${c.id}`} label={c.name} icon={Building2} />)}
            </div>
          )}
          {me.role !== "externe" && <Row id={null} label="Mes fichiers (racine)" icon={Home} />}
          {list.map((f) => <Row key={f.id} id={f.id} label={f.path} icon={Folder} />)}
          {list.length === 0 && <p className="text-xs text-slate-500 p-3">Aucun dossier modifiable</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button onClick={submit} disabled={busy || target === undefined} data-testid="move-dialog-submit">Valider</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
